"use client";
import { FormEvent, useState } from "react";
import toast from "react-hot-toast";

import { CottonServices } from "@/services";
import { ContactPayload } from "@/types";

function useContactForm() {
  const { mutateAsync: contactUs, isPending: contactLoading } =
    CottonServices().useContactUs();
  const [contactPayload, setContactPayload] = useState<ContactPayload>({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    subject: "",
    message: "",
  });

  const resetForm = () => {
    setContactPayload({
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      subject: "",
      message: "",
    });
  };
  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      const response = await contactUs({
        ...contactPayload,
        message: !contactPayload.message
          ? "Web contact"
          : contactPayload.message,
      });

      toast.success(response.data.message ?? "Message sent successfully");
      resetForm();
    } catch (error: any) {
      toast.error(
        error.response.data.message || "Oops! an error occurred, try again",
        { duration: 6000 },
      );
    }
  };

  return { contactLoading, contactPayload, setContactPayload, handleSubmit };
}

export default useContactForm;
